// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    hours: {
      label: 'Horas trabajadas',
      help: 'Una fila por jornada y persona, calculada igual que el registro horario. No lleva ninguna retribución',
    },
    dates: {
      workDate: 'Día trabajado',
    },
    metrics: {
      hours: 'Horas trabajadas',
      days: 'Jornadas',
      people: 'Personas',
      overtime: 'Horas extra',
      paused: 'Horas de pausa',
      openDays: 'Jornadas sin cerrar',
      counted: 'Horas computables',
      warningDays: 'Jornadas con avisos del convenio',
      averageDay: 'Jornada media',
      overtimeShare: 'Peso de las extra',
    },
    dimensions: {
      worker: 'Persona',
      modality: 'Presencial o remoto',
      hourKind: 'Tipo de hora',
      reference: 'Contra qué se fichó',
    },
  },
  ca: {
    hours: {
      label: 'Hores treballades',
      help: 'Una fila per jornada i persona, calculada igual que el registre horari. No porta cap retribució',
    },
    dates: {
      workDate: 'Dia treballat',
    },
    metrics: {
      hours: 'Hores treballades',
      days: 'Jornades',
      people: 'Persones',
      overtime: 'Hores extres',
      paused: 'Hores de pausa',
      openDays: 'Jornades sense tancar',
      counted: 'Hores computables',
      warningDays: 'Jornades amb avisos del conveni',
      averageDay: 'Jornada mitjana',
      overtimeShare: 'Pes de les extres',
    },
    dimensions: {
      worker: 'Persona',
      modality: 'Presencial o remot',
      hourKind: 'Tipus d\'hora',
      reference: 'Contra què es va fitxar',
    },
  },
  en: {
    hours: {
      label: 'Hours worked',
      help: 'One row per worked day per person, computed as the working-time record does. It holds no pay',
    },
    dates: {
      workDate: 'Work date',
    },
    metrics: {
      hours: 'Hours worked',
      days: 'Days worked',
      people: 'People',
      overtime: 'Overtime',
      paused: 'Break hours',
      openDays: 'Days left open',
      counted: 'Counted hours',
      warningDays: 'Days with agreement warnings',
      averageDay: 'Average day',
      overtimeShare: 'Overtime share',
    },
    dimensions: {
      worker: 'Person',
      modality: 'On site or remote',
      hourKind: 'Kind of hour',
      reference: 'Clocked against',
    },
  },
  fr: {
    hours: {
      label: 'Heures travaillées',
      help: 'Une ligne par journée et par personne, calculée comme le registre du temps. Sans aucune rémunération',
    },
    dates: {
      workDate: 'Jour travaillé',
    },
    metrics: {
      hours: 'Heures travaillées',
      days: 'Journées',
      people: 'Personnes',
      overtime: 'Heures supplémentaires',
      paused: 'Heures de pause',
      openDays: 'Journées non clôturées',
      counted: 'Heures comptabilisées',
      warningDays: 'Journées avec alertes de la convention',
      averageDay: 'Journée moyenne',
      overtimeShare: 'Part des heures sup.',
    },
    dimensions: {
      worker: 'Personne',
      modality: 'Sur site ou à distance',
      hourKind: 'Type d\'heure',
      reference: 'Pointé sur',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
